import { useAppContext } from "@/app/context/AppProvider";
import { resetCustomModalContent, setCustomModalContent, setLoading } from "@/app/context/AppProvider/actions";
import { LoaderContent } from "@/components/Loader/type";

export const useLoading = () => {
  const { state, dispatch } = useAppContext();
  const { isLoading } = state;

  const startLoading = () => dispatch(setLoading(true));

  const stopLoading = () => dispatch(setLoading(false));

  const addCustomModalContent = (content: LoaderContent) => dispatch(setCustomModalContent(content));

  const clearModalContent = () => dispatch(resetCustomModalContent());

  return { isLoading, startLoading, stopLoading, addCustomModalContent, clearModalContent };
};
